import type { RefObject } from 'react';
import classNames from 'classnames';
import * as animateStyles from '../animate.module.css';
import * as styles from './whatsNew.module.scss';

const assertBaseUrl = process.env.REACT_APP_ASSETS_BASE_URL;

const copy = [
  {
    title: 'Rate & Review',
    subtitle: 'Leave reviews for the products you ordered and read what other people have to say.',
  },
  {
    title: 'Shop Exclusive Sales',
    subtitle: 'Shop exclusive sales and discounts for members only',
  },
  {
    title: 'Order History',
    subtitle: 'Track shipment statuses on your orders and verify order details all in one place.',
  },
];

type PhoneImageProps = {
  animateBool: boolean;
  imageUrl: string;
  imageRef: RefObject<HTMLDivElement>;
};

const PhoneImage = ({ animateBool, imageUrl, imageRef }: PhoneImageProps) => (
  <div className={styles.phoneImage} ref={imageRef}>
    <img
      src={imageUrl}
      alt="phone-screen"
      className={classNames(animateStyles.fadein, {
        [animateStyles.animate]: animateBool,
      })}
    />
  </div>
);

const AppButtons = () => (
  <div className={styles.store}>
    <a href={process.env.REACT_APP_MOBILE_APP_IOS_URL}>
      <img
        src={`${assertBaseUrl}/images/icon-apple-store.png`}
        alt=""
        className={classNames(animateStyles.hoverbtn, styles.appStore)}
      />
    </a>
    <a href={process.env.REACT_APP_MOBILE_APP_ANDROID_URL}>
      <img
        src={`${assertBaseUrl}/images/icon-google-store_1574120297.6679_1574120298.1544.png`}
        alt=""
        className={classNames(animateStyles.hoverbtn, styles.googlePlay)}
      />
    </a>
  </div>
);

type TextContainerProps = {
  title: string;
  subtitle: string;
};

const TextContainer = ({ title, subtitle }: TextContainerProps) => (
  <div className={styles.textContainer}>
    <h3>{title}</h3>
    <p>{subtitle}</p>
  </div>
);

const Header = () => (
  <>
    <img src={`${assertBaseUrl}/images/fff-app-icon.png`} alt="" className={styles.appIcon} />
    <h2>What&apos;s New!</h2>
    <hr />
  </>
);

type MobileViewProps = {
  phone1Ref: RefObject<HTMLDivElement>;
  phone2Ref: RefObject<HTMLDivElement>;
  phone3Ref: RefObject<HTMLDivElement>;
  phone1AnimateBool: boolean;
  phone2AnimateBool: boolean;
  phone3AnimateBool: boolean;
};

export const MobileView = ({
  phone1Ref,
  phone2Ref,
  phone3Ref,
  phone1AnimateBool,
  phone2AnimateBool,
  phone3AnimateBool,
}: MobileViewProps) => (
  <>
    <Header />
    <TextContainer {...copy[0]} />
    <PhoneImage
      imageRef={phone1Ref}
      imageUrl={`${assertBaseUrl}/images/iphone${3}.png`}
      animateBool={phone1AnimateBool}
    />
    <TextContainer {...copy[1]} />
    <PhoneImage
      imageRef={phone2Ref}
      imageUrl={`${assertBaseUrl}/images/iphone${1}.png`}
      animateBool={phone2AnimateBool}
    />
    <TextContainer {...copy[2]} />
    <PhoneImage
      imageRef={phone3Ref}
      imageUrl={`${assertBaseUrl}/images/iphone${2}.png`}
      animateBool={phone3AnimateBool}
    />
    <AppButtons />
  </>
);

type DesktopViewProps = {
  phone1Ref: RefObject<HTMLDivElement>;
  phone2Ref: RefObject<HTMLDivElement>;
  phone3Ref: RefObject<HTMLDivElement>;
  phone1AnimateBool: boolean;
  phone2AnimateBool: boolean;
  phone3AnimateBool: boolean;
};

export const DesktopView = ({
  phone1Ref,
  phone2Ref,
  phone3Ref,
  phone1AnimateBool,
  phone2AnimateBool,
  phone3AnimateBool,
}: DesktopViewProps) => (
  <>
    <div className={styles.imageContainer}>
      <PhoneImage
        imageRef={phone1Ref}
        imageUrl={`${assertBaseUrl}/images/iphone${3}.png`}
        animateBool={phone1AnimateBool}
      />
      <PhoneImage
        imageRef={phone2Ref}
        imageUrl={`${assertBaseUrl}/images/iphone${1}.png`}
        animateBool={phone2AnimateBool}
      />
      <PhoneImage
        imageRef={phone3Ref}
        imageUrl={`${assertBaseUrl}/images/iphone${2}.png`}
        animateBool={phone3AnimateBool}
      />
    </div>
    <div className={styles.descriptionContainer}>
      <Header />
      {copy.map((c) => (
        <TextContainer key={c.title} {...c} />
      ))}
      <AppButtons />
    </div>
  </>
);
